<ng-container *transloco="let t">
  <div class="flex h-full min-h-0 flex-1 flex-col pt-3">
    <IDataTable [datasource]="dataSource">
      <table iTable class="w-full">
        <thead iTableHead>
          <tr>
            <th iTableTh>
              {{ t("account-setting.organization") }}
              <IBadge [label]="dataSource.dataLength() + ' '" color="gray" size="xs" class="ml-1" />
            </th>
            <th iTableTh>{{ t("common.resources") }}</th>
            <th iTableTh>{{ t("account-setting.default_campaign_label") }}</th>
            <th iTableTh></th>
          </tr>
        </thead>
        <tbody>
          @for (organization of dataSource.data(); track organization.id) {
            <tr
              iTableRow
              app-organization-list-row
              [organization]="organization"
              class="group"
              [isAdmin]="adminOrganizationIds().has(organization.id)"
            ></tr>
          }
        </tbody>
      </table>
    </IDataTable>
  </div>
</ng-container>
